import { render } from "./Buffer.vue?vue&type=template&id=17a20cfa"
import script from "./Buffer.vue?vue&type=script&lang=js"
export * from "./Buffer.vue?vue&type=script&lang=js"

import "./Buffer.vue?vue&type=style&index=0&id=17a20cfa&lang=scss"
script.render = render

export default script